<template>
    <div>
        <template v-if="activeTab === 'records'">
            <div class="documents-progess-section f-14 text-left d-flex align-items-center mb-2"
                v-for="item in visibleMaintenanceBanners" :key="`maint-status-${item.id}`">
                <div class="w-75">
                    <template v-if="item.status === 'Failed'">
                        {{ $t('recordsAndTotal.aiFailed') }}{{ item.desc ? `: ${item.desc}` : '' }}.
                    </template>
                    <template v-else>
                        {{ $t('recordsAndTotal.aiProcessing') }}
                    </template>
                </div>
                <p v-if="item.status === 'Failed'" class="mb-0 text-primary cursor-pointer f-14 ml-auto"
                    @click="dismissMaintenanceTask(item)">{{ $t('recordsAndTotal.dismiss') }}</p>
            </div>
            <p v-if="maintenanceBanners.length > 2"
                class="my-2 text-primary cursor-pointer f-14 text-center"
                @click="showAllMaintBanners = !showAllMaintBanners">
                {{ showAllMaintBanners ? $t('recordsAndTotal.showLess') : $t('recordsAndTotal.showMore', { count: maintenanceBanners.length - 2 }) }}
            </p>
        </template>
        <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-3">
            <h2 class="text-left mb-0">{{ activeTab === 'records' ? $t('recordsAndTotal.records') : activeTab === 'totals' ? $t('recordsAndTotal.totals') : '' }}
            </h2>
            <div class="d-flex justify-content-between justify-content-sm-center flex-wrap">
                <b-button @click="showMaintenaceModal()" v-if="allowAddData && activeTab !== 'totals'"
                    class="export equipment d-flex justify-content-center align-items-center mx-1 my-1 w-fit-content"
                    variant="primary">
                    <b-icon icon="plus" aria-hidden="true"></b-icon>
                    <p class="mb-0 ml-2 text-white">{{ $t('recordsAndTotal.addPrefix') }} {{ activeTab === 'records' ? $t('recordsAndTotal.addRecord') : '' }}</p>
                </b-button>
                 <b-button v-if="activeTab === 'records'"
                    @click="showMaintenaceAIModal()"
                    class="d-flex f-14 justify-content-center align-items-center mr-1 my-1 w-fit-content"
                    variant="outline-primary">
                    <p class="mb-0">{{ $t('recordsAndTotal.importWithAi') }}</p>
                </b-button>
                <b-dropdown id="dropdown-divider" text="text" class="load-dropdown-2"
                    v-if="(allowExportData || allowImportData) && (activeTab !== 'types')">
                    <template slot="button-content">
                        <b-icon class="dots" icon="three-dots"></b-icon>
                    </template>
                    <b-dropdown-item-button
                        :class="activeTab === 'records' && (allowImportData || selectedRowsLength) ? 'mb-2' : ''"
                        v-if="allowExportData" @click="downloadExcel">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('recordsAndTotal.exportCsv') }}</p>
                    </b-dropdown-item-button>
                    <b-dropdown-item-button :class="selectedRowsLength ? 'mb-2' : ''"
                        @click="$bvModal.show('modal-bulk-upload')" v-if="activeTab === 'records' && allowImportData">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('recordsAndTotal.importCsv') }}</p>
                    </b-dropdown-item-button>
                    <b-dropdown-item-button v-if="activeTab === 'records' && selectedRowsLength"
                        @click="$refs.recordsSection.downloadBulkFiles()">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('recordsAndTotal.downloadDocs') }}</p>
                    </b-dropdown-item-button>
                </b-dropdown>
            </div>
        </div>
        <div class="data-table team-data-table bg-white rounded table-custom-border">
            <div class="bg-white rounded">
                <v-tabs class="team-tabs mb-0" show-arrows>
                    <v-tab @click="activeTab = 'records'">{{ $t('recordsAndTotal.records') }}</v-tab>
                    <v-tab @click="activeTab = 'totals'">{{ $t('recordsAndTotal.totals') }}</v-tab>
                </v-tabs>
            </div>
            <div class="bg-white rounded" :class="activeTab !== 'types' ? 'pt-3 pt-sm-4':''">
                <div class="table_row">
                    <Records v-if="activeTab === 'records'" ref="recordsSection" :allowAddRecord="allowAddRecord"
                        @getSelectedRowsLength="selectedRowsLength = $event" @close="allowAddRecord = false" />
                    <Totals v-if="activeTab === 'totals'" ref="totalSection" />
                </div>
            </div>
        </div>
        <DeleteModal v-if="showModal" @confirm="deleteItem($event)" />
        <ImportWithAI @extractionQueued="onExtractionQueued" />
        <!-- Import CSV Modal  -->
        <b-modal id="modal-bulk-upload" centered hide-footer :title="$t('recordsAndTotal.importCsvTitle')" @shown="resetField" no-close-on-backdrop>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('recordsAndTotal.importCsvTitle') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="d-block text-center">
                <b-row class="import-excel-modal mx-0">
                    <b-col cols="12" class="px-0">
                        <div class="upload-btn-wrapper mt-0">
                            <b-img :src="require('@/assets/drop.svg')"></b-img>
                            <button class="foo" v-if="!fileName">
                                {{ $t('recordsAndTotal.dropDocument') }}
                            </button>
                            <button v-else class="foo">{{ fileName }}</button>
                            <input ref="docFile" type="file" name="docFile" @change="handleFileUpload" accept=".csv" />
                            <p v-if="errors && errors.document" class="field-error">
                                {{ errors.document }}
                            </p>
                        </div>
                    </b-col>
                    <b-col cols="12" class="text-left cursor-pointer mt-2 pt-1 pl-1">
                        <a class="download-sample-file"
                            :href="activeTab === 'records' ? '/files/RecordsSample.csv' : '/files/ScheduleSample.csv'"
                            download="sample.csv">
                            <b-img :src="require('@/assets/sample-file.svg')"></b-img>
                            {{ $t('recordsAndTotal.downloadSample') }}
                        </a>
                    </b-col>
                </b-row>
            </div>
            <div class="text-right modal-footer border-0 p-0">
                <b-button class="mx-0 mr-3 h-40px w-100px" @click="$bvModal.hide('modal-bulk-upload')"
                    variant="secondary">{{ $t('maintenanceShared.cancel') }}</b-button>
                <b-button class="mx-0 mb-0 h-40px w-100px" variant="primary" @click="bulkUploadData">{{ $t('maintenanceShared.save') }}</b-button>
            </div>
        </b-modal>
        <!-- Bulk Upload Errors Modal -->
        <b-modal id="modal-bulk-upload-errors" centered hide-footer size="md" no-close-on-backdrop>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('recordsAndTotal.csvImportErrors') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="bulk-upload-errors-container">
                <p v-if="bulkUploadSummary" class="mb-3 font-weight-bold">{{ bulkUploadSummary }}</p>
                <div class="errors-list" style="max-height: 400px; overflow-y: auto;">
                    <div v-for="(error, index) in bulkUploadErrors" :key="index" class="error-item mb-2 p-2" style="background: #fff3f3; border-left: 3px solid #dc3545; border-radius: 4px;">
                        <p class="mb-0"><strong>{{ error.row }}:</strong> {{ error.message }}</p>
                    </div>
                </div>
            </div>
            <div class="text-right modal-footer border-0 p-0 mt-3">
                <b-button class="mx-0 h-40px w-100px" @click="$bvModal.hide('modal-bulk-upload-errors')" variant="primary">{{ $t('maintenanceShared.close') }}</b-button>
            </div>
        </b-modal>
    </div>
</template>
  
<script>
import { mapActions, mapGetters } from "vuex";

import DeleteModal from "@/components/DeleteModal.vue";
import Records from "@/components/Maintenance/Records.vue";
import Totals from "@/components/Maintenance/Totals";
import ImportWithAI from "./ImportWithAI.vue";
export default {
    name: "RecordsAndTotal",
    components: {
        DeleteModal,
        Records,
        Totals,
        ImportWithAI
    },
    data() {
        return {
            activeTab: "records",
            maintenanceSchedulePopup: false,
            allowAddRecord: false,
            itemId: 0,
            selectedRowsLength: 0,
            showModal: false,
            deleteMaintenanceItem: false,
            fileName: null,
            document: null,
            bulkUploadErrors: [],
            bulkUploadSummary: '',
            errors: {
                document: null,
            },
            maintenanceBanners: [],
            showAllMaintBanners: false,
        };
    },
    computed: {
        ...mapGetters(["maintenance", "company", "allEquipments", "maintenanceSchedule", "rolePermissions"]),
        visibleMaintenanceBanners() {
            return this.showAllMaintBanners
                ? this.maintenanceBanners
                : this.maintenanceBanners.slice(0, 2);
        },
        getAICredits(){
            return this.company[0]?.ai_credits || 0
        },
        allowAddData() {
            return this.rolePermissions && this.rolePermissions['Maintenance'] && this.rolePermissions['Maintenance'][2].allow
        },
        allowImportData() {
            return this.rolePermissions && this.rolePermissions['Maintenance'] && this.rolePermissions['Maintenance'][4].allow
        },
        allowExportData() {
            return this.rolePermissions && this.rolePermissions['Maintenance'] && this.rolePermissions['Maintenance'][5].allow
        },
        allowAIImport() {
            return this.company[0]?.allow_ai_maintenance_import === true
        }
    },
    methods: {
        ...mapActions([
            "getMaintenance",
            "setNotification",
            "deleteMaintenance",
            "getMaintenanceSchedule",
            "deleteMaintenance",
            "deleteMaintenanceSchedule",
            "addBulkMaintenanceRecords",
            "addBulkMaintenanceSchedule",
            "getMaintenanceExtractList",
            "dismissMaintenanceExtractTask",
            "setLoader"
        ]),
        showMaintenaceAIModal() {
            if(this.getAICredits > 0) {
            this.$bvModal.show('modal-import-ai')
            }
            else{
                this.setNotification({
                    msg: this.$t('recordsAndTotal.noAICredits'),
                    type: "error",
                    color: "red",
                });
            }
        },
        async getMaintenanceUploadStatus() {
            try {
                const data = await this.getMaintenanceExtractList();
                const list = Array.isArray(data) ? data : (data ? [data] : []);
                const activeStatuses = ['Queued', 'Uploading', 'Extracting', 'In Progress', 'Failed'];
                this.maintenanceBanners = list.filter(item => activeStatuses.includes(item.status));
            } catch (e) {
                console.log(e);
            }
        },
        async dismissMaintenanceTask(item) {
            try {
                await this.dismissMaintenanceExtractTask({
                    id: item.id,
                    payload: { dismissed: true },
                });
                this.maintenanceBanners = this.maintenanceBanners.filter(i => i.id !== item.id);
            } catch (e) {
                console.log(e);
            }
        },
        async downloadExcel() {
            if (this.activeTab === 'records') await this.$refs.recordsSection.downloadExcel()
            else await this.$refs.totalSection.downloadExcel()
        },
        resetField() {
            this.$refs.docFile.value = null;
            this.fileName = null;
            this.document = null;
            this.errors = {
                document: null,
            };
        },
        handleFileUpload() {
            this.document = this.$refs.docFile.files[0];
            this.fileName = this.document.name;
        },
        async onExtractionQueued() {
            if (this.$refs.recordsSection) {
                await this.$refs.recordsSection.getMaintenanceData();
            }
            await this.getMaintenanceUploadStatus();
        },
        showMaintenaceModal() {
            if (this.activeTab === 'records') this.allowAddRecord = true
        },
        deleteItem(item) {
            if (item) {
                this.deleteRecord(this.itemId);
            }
            this.showModal = false;
            this.deleteMaintenanceItem = false;
        },
        async bulkUploadData() {
            if (this.document) {
                this.setLoader(true)
                this.errors = {
                    document: null,
                };
                try {
                    let formData = new FormData();
                    formData.append("file", this.document);
                    const newRecords = await this.addBulkMaintenanceRecords(formData)
                    if (newRecords) {
                        // await this.getTeamMemberData();
                        await this.setNotification({
                            msg: this.$t('recordsAndTotal.importedSuccess'),
                            type: "success",
                            color: "green",
                        });
                        await this.$refs.recordsSection.getMaintenanceData()
                        this.$bvModal.hide("modal-bulk-upload");
                        this.setLoader(false)
                    }
                } catch (e) {
                    this.setLoader(false)
                    if ("equipment" in e) {
                        await this.setNotification({
                            msg: e["equipment"][0],
                            type: "error",
                            color: "red",
                        });
                    } else if (typeof e === 'object' && e !== null) {
                        // Parse row errors from the response
                        this.bulkUploadErrors = [];
                        this.bulkUploadSummary = e.summary || '';
                        Object.keys(e).forEach((key) => {
                            if (key.startsWith('row no:')) {
                                this.bulkUploadErrors.push({
                                    row: key,
                                    message: e[key]
                                });
                            }
                        });
                        if (this.bulkUploadErrors.length > 0) {
                            this.$bvModal.hide('modal-bulk-upload');
                            this.$bvModal.show('modal-bulk-upload-errors');
                        } else {
                            await this.setNotification({
                                msg: this.$t('recordsAndTotal.wrongFields'),
                                type: "error",
                                color: "red",
                            });
                        }
                    } else {
                        await this.setNotification({
                            msg: this.$t('recordsAndTotal.wrongFields'),
                            type: "error",
                            color: "red",
                        });
                    }
                }
            } else {
                this.errors = {
                    document: this.$t('maintenanceShared.fieldRequired'),
                };
            }
        },
    },
    async mounted() {
        await this.getMaintenanceUploadStatus();
    },
};
</script>
  
<style>
.with-border {
    position: relative;
}

.with-border::after {
    content: "";
    position: absolute;
    right: 0;
    top: 25%;
    height: 50%;
    width: 1px;
    background-color: #e3e3e3;
}
</style>
  